/**
 * Charge de manière différée le script de Google Recaptcha.
 */
export default class GoogleRecaptcha {
    constructor($view) {
        const $form = $view.prop('tagName').toLowerCase() === 'form' ? $view : $view.find('form');

        if ( ! $form || $form.length === 0) {
            return;
        }

        /**
         * Action du formulaire à faire valider par recaptcha.
         * @type {string}|null
         */
        this.action = $view.data('recaptchaAction');

        /**
         * Élément formulaire.
         */
        this.form = $form[0];

        /**
         * Clé d'API Recaptcha.
         * @type {string}
         */
        this.key = '6LeDHKUZAAAAAFDu-VHMbBKjHQAt3PegeRe-GSCS';

        /**
         * Détermine si le script a déjà été chargé.
         * @type {boolean}
         */
        this.scriptAlreadyThere = !! document.getElementById('gReCaptchaScript');

        this.bind();
    }

    bind() {
        this.declareRecaptchaFunctions();
        this.watch();
    }

    /**
     * Écoute les événements du composant.
     */
    watch() {
        // Charge le script de l'API recaptcha lorsque l'internaute commence à remplir le formulaire
        this.form.addEventListener('focus', this.loadRecaptchaScripts, true);
    }

    /**
     * Charge en asynchrône l'API ReCaptcha.
     */
    loadRecaptchaScripts() {
        if ( ! this.scriptAlreadyThere) {
            const reCaptchaScript = document.createElement('script');
            reCaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render='+this.key+'&hl=en&onload=onloadCallback');
            reCaptchaScript.async = true;
            document.head.appendChild(reCaptchaScript);
            this.scriptAlreadyThere = true;
        }
    }

    /**
     * Déclare les fonctions utilisées par Recaptcha.
     */
    declareRecaptchaFunctions() {
        const self = this;

        // Rafraîchit le champ recaptcha du formulaire
        window.refreshReCaptchaV3 = window.refreshReCaptchaV3 || function (fieldId,action,cb){
            grecaptcha.reset(window['client'+fieldId]);
            grecaptcha.ready(function () {
                grecaptcha.execute(window['client'+fieldId], {
                    action: action
                }).then(function (token) {
                    if (cb) {
                        cb(token);
                    }
                });
            });
        };

        // Cherche par l'API la valeur du champ recaptcha
        window.getReCaptchaV3Response = window.getReCaptchaV3Response || function (fieldId) {
            return grecaptcha.getResponse(window['client'+fieldId]);
        };

        // Callback exécuté à la fin du chargement de l'API recaptcha
        window.onloadCallback = window.onloadCallback || function () {
            for(let action of self.getRecaptchaActions()) {
                let fieldId = action+'_id';

                if (document.getElementById(fieldId)) {
                    window['client'+fieldId] = grecaptcha.render(fieldId, {
                        'sitekey': self.key,
                        'badge': 'inline',
                        'size': 'invisible',
                        'hl': 'en',
                        'callback': function() {}
                    });
                    grecaptcha.ready(function () {
                        grecaptcha.execute(window['client'+fieldId], {
                            action: action
                        });
                    });
                }
            }
        };
    }

    /**
     * Liste des actions recensées pour recaptcha sur le site.
     * @returns {string[]}
     */
    getRecaptchaActions() {
        return [
            'contact_us',
            'property_contact_us',
            'save_search',
            'save_newsletter'
        ];
    }
}
